import React from 'react';

const VSvgPayoutIcon = ({ className, width = '24', height = '24' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6C3.44772 6 3 6.44772 3 7V17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V7C21 6.44772 20.5523 6 20 6H4ZM1 7C1 5.34315 2.34315 4 4 4H20C21.6569 4 23 5.34315 23 7V17C23 18.6569 21.6569 20 20 20H4C2.34315 20 1 18.6569 1 17V7Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 10C1 9.44772 1.44772 9 2 9H22C22.5523 9 23 9.44772 23 10C23 10.5523 22.5523 11 22 11H2C1.44772 11 1 10.5523 1 10Z" fill="currentColor" />
        </svg>
    )
}

export default VSvgPayoutIcon;

